export default {
  item: {
    type: Object,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/Items/resources/props.js